

import React, { useEffect } from 'react';

const Popup = ({ onClose }) => {
  useEffect(() => {
    // Optional: autoplay works only if allowed by browser + muted by default
  }, []);

  return (
    <div className="popup-overlay">
      <div className="popup-wrapper">
        {/* Close button near video, outside iframe */}
        <button className="close-button !bg-white font-bold" onClick={onClose}>×</button>

        <div className="popup-container">
          <iframe
            className="responsive-video"
            src="https://www.youtube.com/embed/VTjUlJIXoJw?autoplay=1&mute=1&loop=1&playlist=VTjUlJIXoJw&cc_load_policy=0"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          ></iframe>
        </div>
      </div>

      <style>{`
        .popup-overlay {
          position: fixed;
          top: 0; left: 0; right: 0; bottom: 0;
          background-color:;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
          padding: 1rem;
          backdrop-filter: blur(15px);
          -webkit-backdrop-filter: blur(8px);
        }

        .popup-wrapper {
          position: relative;
          display: inline-block;
        }

// .popup-container {
//   width: 1000px;
//   height: 700px;
//   background-color: white; /* white background */
//   border-radius: 12px;
//   overflow: hidden;
//   animation: slideDown 0.6s ease-out;
//   display: flex;
//   align-items: center;
//   justify-content: center;
// }

//    .responsive-video {
//   width: 100%;
//   height: 100%;
//   background-color: white; /* just in case the iframe doesn't fully cover */
// }


.popup-container {
  width: 1000px;
  aspect-ratio: 16 / 9;
  background-color: white;
  border-radius: 12px;
  // border: 2px solid #000000;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.responsive-video {
  width: 100%;
  height: 100%;
  background-color: white;
}
 
.close-button {
  position: absolute;
  top: -20px;
  right: -16px;
  background-color: #ccc;
  border: 2px solid #AD2F3B;
  border-radius: 50%;
  font-size: 34px;
  width: 40px;
  height: 40px;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(196, 70, 70, 0.3);
  z-index: 1001;
  color: #AD2F3B; /* Maroon “×” */
  display: flex;
  align-items: center;
  justify-content: center;
}


        @keyframes slideDown {
          from {
            transform: translateY(-100%);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }

        @media (max-width: 440px) {
//           .popup-container {
//   width: 90vw;
//   height: auto;
//   aspect-ratio: 4 / 3;
//   background-color: white;
//   display: flex;
//   align-items: center;
//   justify-content: center;
// }

// .responsive-video {
//   width: 100%;
//   height: 100%;
//   aspect-ratio: 4 / 3;
//   background-color: white;
// }


.popup-container {
  width: 90vw;
  aspect-ratio: 16 / 9;
  background-color: white;
}

.responsive-video {
  width: 100%;
  height: 100%;
  background-color: white;
}


.close-button {
  top: -50px;
  right: -12px;
  width: 32px;
  height: 32px;
  font-size: 28px;
  background: !white;
  color: #AD2F3B;  /* Added here too for mobile */
  border: 2px solid #AD2F3B;

}


          // .popup-overlay  {
          //   backdrop-filter: none !important;
          //   -webkit-backdrop-filter: none !important;
          //   background-color: #ffffff;
          // }
        }
      `}</style>
    </div>
  );
};

export default Popup;

// import React, { useEffect } from 'react';

// const Popup = ({ onClose }) => {
//   useEffect(() => {}, []);

//   return (
//     <div className="popup-overlay">
//       <div className="popup-wrapper">
//         <button className="close-button font-bold" onClick={onClose}>
//           ×
//         </button>

//         <div className="popup-container">
//           <div className="video-wrapper">
//             <iframe
//               className="responsive-video"
//               src="https://www.youtube.com/embed/VTjUlJIXoJw?autoplay=1&mute=1&loop=1&playlist=VTjUlJIXoJw&cc_load_policy=0"
//               title="YouTube video player"
//               frameBorder="0"
//               allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
//               allowFullScreen
//             ></iframe>
//           </div>
//         </div>
//       </div>

//       <style>{`
//         .popup-overlay {
//           position: fixed;
//           top: 0; left: 0; right: 0; bottom: 0;
//           background-color: rgba(0, 0, 0, 0.6);
//           backdrop-filter: blur(10px);
//           -webkit-backdrop-filter: blur(10px);
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           z-index: 1000;
//         }

//         .popup-wrapper {
//           position: relative;
//           display: inline-block;
//         }

//         .popup-container {
//           width: 1000px;
//           background-color: white;
//           border-radius: 12px;
//           overflow: hidden;
//           box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
//         }

//         .video-wrapper {
//           padding: 20px 35px;
//           background-color: white;
//           aspect-ratio: 16 / 9;
//         }

//         .responsive-video {
//           width: 100%;
//           height: 100%;
//           display: block;
//           background-color: white;
//           border: none;
//         }

//         .close-button {
//           position: absolute;
//           top: -20px;
//           right: -16px;
//           background-color: white;
//           border: 2px solid #ccc;
//           border-radius: 50%;
//           font-size: 24px;
//           width: 40px;
//           height: 40px;
//           cursor: pointer;
//           box-shadow: 0 2px 6px rgba(0,0,0,0.3);
//           z-index: 1001;
//           color: #AD2F3B;
//         }

//         @media (max-width: 440px) {
//           .popup-container {
//             width: 90vw;
//           }

//           .video-wrapper {
//             padding: 12px;
//             aspect-ratio: 16 / 9;
//           }

//           .responsive-video {
//             width: 100%;
//             height: 100%;
//           }

//           .close-button {
//             top: -50px;
//             right: -12px;
//             width: 32px;
//             height: 32px;
//             font-size: 20px;
//           }
//         }
//       `}</style>
//     </div>
//   );
// };

// export default Popup;
